export function managerSlug(name) {
  if (!name) return '';
  return name
    .toLowerCase()
    .replace(/\./g, '-')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .trim();
}

export function slugToManager(slug, managers) {
  if (!slug || !Array.isArray(managers)) return null;
  return managers.find((m) => managerSlug(m) === slug) || null;
}
